export enum FilterCheckbox {
  DEFAULT = 0,
  INCLUDE = 1,
  EXCLUDE = 2
}

export interface MeldungBewilligungFilterType {
  dthUploaded : FilterCheckbox;
  lepUploaded : FilterCheckbox;
  btmUploaded : FilterCheckbox;
  labUploaded : FilterCheckbox;
  blvRequired : FilterCheckbox;
  blvUploaded : FilterCheckbox;
}

export class MeldungBewilligungFilter implements MeldungBewilligungFilterType {
  dthUploaded : FilterCheckbox = FilterCheckbox.DEFAULT;
  lepUploaded : FilterCheckbox = FilterCheckbox.DEFAULT;
  btmUploaded : FilterCheckbox = FilterCheckbox.DEFAULT;
  labUploaded : FilterCheckbox = FilterCheckbox.DEFAULT;
  blvRequired : FilterCheckbox = FilterCheckbox.DEFAULT;
  blvUploaded : FilterCheckbox = FilterCheckbox.DEFAULT;

  public constructor(init?: Partial<MeldungBewilligungFilter>) {
    Object.assign(this, init);
  }

  anyAktiv(): boolean {
    return (
      this.dthUploaded !== FilterCheckbox.DEFAULT ||
      this.lepUploaded !== FilterCheckbox.DEFAULT ||
      this.btmUploaded !== FilterCheckbox.DEFAULT ||
      this.labUploaded !== FilterCheckbox.DEFAULT ||
      this.blvRequired !== FilterCheckbox.DEFAULT ||
      this.blvUploaded !== FilterCheckbox.DEFAULT
    );
  }
}
